module.exports = __webpack_public_path__ + "kaitak-ogp-lp7-220623.9bb49a63e1a7b9d773c4.jpg";